module.exports = __webpack_public_path__ + "assets/campaign-delete.b314c55b.svg";